module.exports = __webpack_public_path__ + "fromGroomToMother-jp-n.0024a35a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToMother-jp-n.jpg
// module id = u/ih
// module chunks = 0